import React from "react";
import PrivateApi from "../../services/PrivateApiService";
import SplashPage from '../SplashPage';
import { useNavigate, useParams } from "react-router-dom";
import { Col, Container, Row, Button } from "react-bootstrap";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useQuery } from "react-query";
import { CgSandClock } from "react-icons/cg";
import { useAuthState } from "../../context/AuthContext";
import ErrorPage from "../ErrorPage";
import ContractCard from "../../components/elvs/details/ContractCard";
import ActionsCard from "../../components/elvs/details/ActionsCard";
import DocumentsCard from "../../components/elvs/details/DocumentsCard";
import TicketsCard from "../../components/elvs/details/TicketsCard";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

/**
 * ElvDetailPage
 * 
 * get single Elv details and on click gets Abrechnung, Poolrechnung,
 * Vorschreibung from that Elv.
 * 
 * @returns None
 */
const ElvDetailPage = () => {

    const API = new PrivateApi(); // API calls
    const { user } = useAuthState();
    const { elv_id } = useParams(); // elv id paramater passed
    const navigate = useNavigate();


    // API call 
    const { data, error, isLoading } = useQuery(["GET_ELV_DETAILS_QUERY", elv_id], () => API.get_ElvsDetail(elv_id), {
        staleTime: Infinity,
        enabled: elv_id !== null,
    });


    // GUI
    if (isLoading) return <SplashPage />
    if (error) return <ErrorPage error={error} />

    return (
        <Container>
            <Row className="align-items-center">
                <Col>
                    <h3>Energieliefervertrag</h3>

                </Col>
                <Col className="text-end">
                    <Button
                        onClick={() => navigate(`${user.x_is_house_management ? `/hw/dashboard/energieliefervertraege/zeitverlauf/${data.elv.x_kunde_id[0]}/` : '/dashboard/zeitverlauf/'}${data.elv.x_anlage_id.x_studio_field_mWMGR}`)}
                        className="btn-energo rounded-pill"
                    >
                        <CgSandClock size={25} /> Ansicht: Zeitverlauf
                    </Button>
                </Col>
            </Row>

            <Row className="mt-5">
                {data.x_pastelv_id !== false || data.elv.x_futureelv_id.length > 0 ?
                    <div className="d-flex gap-3 justify-content-center">
                        <a href={`/hw/dashboard/energieliefervertraege/${data.x_pastelv_id}`} className="link-energo" hidden={data.x_pastelv_id === false}>
                            <FaChevronLeft />
                            Vorheriger
                        </a>
                        Energieliefervertrag
                        <a href={`/hw/dashboard/energieliefervertraege/${data.elv.x_futureelv_id.length > 0? data.elv.x_futureelv_id[0]: ''}`} className="link-energo"
                            hidden={data.elv.x_futureelv_id.length === 0}
                            >
                            Nächster 
                            <FaChevronRight />
                        </a>
                    </div>
                    :null
                }
            </Row>

            <Row>
                <Col>
                    <ContractCard elv={data.elv} energieprodukt={data.energieprodukt} />
                </Col>
            </Row>

            <Row className="mt-5">
                <Col>
                    <ActionsCard elv={data.elv} energieprodukt={data.energieprodukt} tickets={data.tickets} />
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12" md="6" xl="6">
                    <DocumentsCard
                        abrechnungen={data.abrechnungen}
                        vorschreibungen={data.vorschreibungen}
                        poolrechnungen={data.poolrechnungen}
                    />
                </Col>
                <Col xs="12" md="6" xl="6">
                    <TicketsCard tickets={data.tickets} />
                </Col>
            </Row>

        </Container>
    )
}

export default ElvDetailPage;